import { getProp } from '@ocp-zmarta/zmarta-cl'

const countrySpecific = (country) => require(`./${country}`).default

export const getMeta = (route, country) => {
  return getProp(countrySpecific(country), 'meta', route) || {}
}

export default countrySpecific
